// extracted by mini-css-extract-plugin
export default {"footerContainer":"A6KMOv","disclaimerContainer":"gbqyzP","disclaimerContainerHidden":"wSPkNO","disclaimerText":"ExXe4H","poweredBy":"rUtnzT"};